import type { QuickSaveState } from '../hooks/useQuickSaveState';

type RequiredFormState = Pick<
    QuickSaveState,
    'title' | 'selectedArchive' | 'selectedCategory' | 'selectedCase' | 'caseConnection' | 'showRecordTypes' | 'selectedRecordType'
>;

export const isQuickSaveFormComplete = (state: RequiredFormState): boolean => Boolean(
    state.title.trim() &&
    state.selectedArchive &&
    state.selectedCategory &&
    (state.caseConnection === 0 || state.selectedCase) &&
    (!state.showRecordTypes || state.selectedRecordType)
);